







































































































































































































































































































































































































































































































































import BaseVue from "@/core/BaseVue";
import { Component, Vue, Watch } from "vue-property-decorator";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import BaseHttpClient from "@/core/HttpResources/BaseHttpClient";
import GenericAdd from "@/core/Generics/GenericAdd";
import Institucion from "../../models/institucion.model";
import TramiteBeneficiario from "@/models/tramite/tramiteBeneficiario.model";
import TipoTramite from "@/models/tipoTramite/tipoTramite.model";
import FileService from "@/services/file.service";
import TramiteBeneficiarioContentModel from "@/models/tramite/content/tramiteBeneficiarioContent.model";
import {
  ComponentImportConfig,
  ComponentDesignConfig,
  TipoTramiteDocumento
} from "@/models/tipoTramite/index";
import ApiQueryOption from "../../models/base/ApiQueryOption.model";
import Persona from "@/models/persona/persona.model";
import Beneficiario from "@/models/beneficiario/beneficiario.model";
import TramiteBeneficiarioContent from "./content.vue";
import TramiteBeneficiarioResumen from "./resumen.vue";
import { SectionSetting } from "@/models/formDesigner/formDesignerControl.model";
import Documento from "@/models/documento.model";
import TramiteBeneficiarioDocumento from "@/models/tramite/tramiteBeneficiarioDocumento.model";
import NameValue from "@/models/nameValue.model";
import BTableConfig from "@/core/BTableConfig/BTableConfig";
import TipoTramiteNota from "@/models/tipoTramite/tipoTramiteNota.model";
import BTableColumn from "@/models/base/BTableColumn.model";
import SolicitudEvaluacionHogarModel, {
  SolicitudEvaluacionHogarMiembro,
  SolicitudEvaluacionHogarMiembroDocumento
} from "@/models/tramite/solicitud-evaluacion-hogar";
import PersonaDireccion from "@/models/persona/personaDireccion.model";
import Miembro from "@/models/miembro/miembro.model";
import Telefono from "@/models/telefono.model";
import Hogar from "@/models/hogar/hogar.model";
import Direccion from "@/models/direccion.model";
import Helpers from "@/helpers/helper";
import { BTableColumnType } from "@/enums/BTableColumnType";
import { Utils } from "@/core/Utils";
import { RowTable } from "@/typings/BRowTable";
import MiembroAdd from "@/components/miembro/add.vue";
import moment from "moment";
import { TipoTramiteCode } from "@/enums/TipoTramiteCode";

@Component({
  components: { TramiteBeneficiarioContent, TramiteBeneficiarioResumen }
})
export default class TramiteEvaluacionHogar extends GenericAdd<
  TramiteBeneficiario
> {
  solicitante = new Persona();
  tipoTramite = new TipoTramite();
  tipoDocumentos: any[] = [];
  direccionesTableConfig!: BTableConfig<PersonaDireccion>;
  direccionPropuestaInit = new Direccion();
  direccionPropuesta = this.map<Direccion>(this.direccionPropuestaInit);
  nameValue = new NameValue();
  parentesco = new NameValue();
  miembrosTableConfig: BTableConfig<SolicitudEvaluacionHogarMiembro>;
  miembroAddCedula: Miembro | undefined | null = null;
  miembroAddSinCedula: Miembro | undefined | null = null;
  adding = false;
  activeTabMiembroAdd = 0;
  editing = false;
  editingMiembro: SolicitudEvaluacionHogarMiembro | undefined | null = null;
  editingMiembroModel:
    | SolicitudEvaluacionHogarMiembro
    | undefined
    | null = null;
  editingMiembroToSave: SolicitudEvaluacionHogarMiembro | null = null;
  loading = false;
  solicitudEvaluacionHogar = new SolicitudEvaluacionHogarModel();
  TipoTramiteCode = TipoTramiteCode;
  centroAcamicoSelected = new NameValue();

  constructor() {
    super();
    this.controller = "TramiteBeneficiario";
    this.model = new TramiteBeneficiario();
    this.miembrosTableConfig = new BTableConfig<
      SolicitudEvaluacionHogarMiembro
    >();
    this.miembrosTableConfig.loadOnMount = false;
    this.miembrosTableConfig.showReload = false;
    this.miembrosTableConfig.enableDefaultColumns = false;
    this.miembrosTableConfig.actions.remove = this.onRemoveMiembro;
    this.miembrosTableConfig.actions.edit = this.onEditMiembro;
    // this.miembrosTableConfig.detailed = true;
    // this.miembrosTableConfig.detailing.key = 'personaId'

    let active = new BTableColumn("key", " ", false);
    active.customTemplate = true;
    active.width = "60";
    let nombre = new BTableColumn("persona.nombre1", "Nombre");
    nombre.customTemplate = true;
    nombre.templateSlot = "nombre1";
    let cedula = new BTableColumn("persona.cedula", "Cédula");
    cedula.type = BTableColumnType.Custom;
    cedula.customFilter = Helpers.Filters.Cedula;
    let edad = new BTableColumn("persona.fechaNacimiento", "Edad");
    edad.customTemplate = true;
    edad.templateSlot = "column-edad";
    let parentesco = new BTableColumn("parentescoNombre", "Parentesco", false);
    let sexo = new BTableColumn("persona.sexo", "Genero");
    sexo.type = BTableColumnType.Custom;
    sexo.customFilter = Helpers.Filters.Sexo;

    this.miembrosTableConfig.insertColumns(
      active,
      nombre,
      cedula,
      edad,
      parentesco,
      sexo
    );
  }
  async created() {
    this.$store.dispatch("mobileShowNavbarInMobile", true);
    await this.initData();
    await this.getipoTramite();
  }
  async initData() {
    try {
      this.loading = true;
      this.solicitante = this.copy(this.user.persona || new Persona());
      this.model.personaId = this.solicitante.id;
      this.solicitudEvaluacionHogar.personaId = this.solicitante.id;
      this.solicitudEvaluacionHogar.estadoCivil = this.solicitante.estadoCivil;
      this.solicitudEvaluacionHogar.centroAcademicoId = this.solicitante.centroAcademicoId;
      this.solicitudEvaluacionHogar.cursoEstudiante = this.solicitante.cursoEstudiante;
      this.solicitudEvaluacionHogar.discapacitado = this.solicitante.discapacitado;
      this.solicitudEvaluacionHogar.incapacitado = this.solicitante.incapacitado;
      this.solicitudEvaluacionHogar.lee = this.solicitante.lee;
      this.solicitudEvaluacionHogar.escribe = this.solicitante.escribe;
      this.solicitudEvaluacionHogar.embarazada = this.solicitante.embarazada;
      this.solicitudEvaluacionHogar.tiempoEmbarazo = this.solicitante.tiempoEmbarazo;
      this.solicitudEvaluacionHogar.medidaTiempoEmbarazo =
        this.solicitante.medidaTiempoEmbarazo;
    } catch (errors) {
      this.operationFailedErrors(errors);
    } finally {
      this.loading = false;
    }
  }
  async getipoTramite() {
    try {
      this.loading = true;
      this.tipoTramite = await new BaseRepository<TipoTramite>("tipoTramite").one(
        `codigo="SolicitudEvaluacionHogar"`
      );
      this.model.tipoTramiteId = this.tipoTramite.id;
      this.nameValue = await new BaseRepository<NameValue>("namevalues").one(
        `codigo="TiposCambiosComposicionFamiliarInclusion"`
      );
    } catch (errors) {
      this.operationFailedErrors(errors);
    } finally {
      this.loading = false;
    }
  }
  backtoProfile() {
    this.$router.push("/");
  }
  repoPersona = new BaseRepository<Persona>("Personas");
  get miembroRows() {
    return this.miembrosTableConfig.data;
  }
  showModalMiembroRow(row: any) {
    this.miembroRows.forEach((x: any) => {
      if (x.key === row.key) {
        x.active = true;
        this.$forceUpdate();
      }
    });
  }

  hideModalMiembroRow(row: any) {
    this.miembroRows.forEach((x: any) => {
      if (x.key === row.key) {
        x.active = false;
        this.$forceUpdate();
      }
    });
  }
  getNombreCompleto(persona: Persona) {
    let n1 = persona.nombre1;
    let n2 = persona.nombre2;
    let a1 = persona.apellido1;
    let a2 = persona.apellido2;
    let full = n1;
    if (n2) full = full + " " + n2;
    if (a1) full = full + " " + a1;
    if (a2) full = full + " " + a2;
    return full;
  }
  get solicitanteId() {
    return this.solicitante.id;
  }
  get cedula() {
    return this.solicitante.cedula;
  }
  get isMobile() {
    return this.$store.state.isMobile;
  }

  onTelefonosChange(telefonos: Telefono[]) {
    this.solicitudEvaluacionHogar.telefonos = [];
    telefonos.forEach(tel => this.solicitudEvaluacionHogar.telefonos.push(tel));
  }
  onCorreosChange(correos: string[]) {
    this.solicitudEvaluacionHogar.listaCorreos = [];
    correos.forEach(mail =>
      this.solicitudEvaluacionHogar.listaCorreos.push(mail)
    );
    this.solicitudEvaluacionHogar.correos = correos.join(";");
  }
  onSelect(selected: PersonaDireccion, oldSelected: PersonaDireccion) {
    this.direccionPropuesta = selected.direccion as Direccion;
    this.solicitudEvaluacionHogar.direccionId = this.direccionPropuesta.id;
  }

  onAdd(added: PersonaDireccion) {
    this.direccionPropuesta = added.direccion as Direccion;
    this.solicitudEvaluacionHogar.direccionId = this.direccionPropuesta.id;
  }

  onLoadTable(config: BTableConfig<PersonaDireccion>) {
    this.direccionesTableConfig = config;
  }
  quitDireccion() {
    this.direccionPropuesta = this.map<Direccion>(this.direccionPropuestaInit);
    this.direccionesTableConfig.selection.selected = null;
    this.solicitudEvaluacionHogar.direccionId = undefined;
  }
  public onRemoveMiembro(
    id: number,
    row: SolicitudEvaluacionHogarMiembro,
    props: RowTable<SolicitudEvaluacionHogarMiembro>
  ) {
    this.$buefy.dialog.confirm({
      title: "Confirmación",
      message: "¿Desea eliminar este miembro?",
      confirmText: "Adelante!",
      cancelText: "Cancelar",
      type: "is-danger",
      size: "is-medium",
      hasIcon: true,
      onConfirm: () => {
        let index = this.miembrosTableConfig.data.findIndex(
          x => x.key === row.key
        );
        this.miembrosTableConfig.data.splice(index, 1);
        let indexx = this.solicitudEvaluacionHogar.miembros.findIndex(
          x => x.key === row.key
        );
        this.solicitudEvaluacionHogar.miembros.splice(indexx, 1);
        //this.setMiembros();
      }
    });
  }
  addingMiembro = false;

  quitCedulaMask(cedula?: string) {
    if (cedula) return cedula.replace(/-/g, "");
    return "";
  }

  public async onAddMiembro() {
    let addingMiembro = this
      .miembroAddSinCedula as SolicitudEvaluacionHogarMiembro;
    let data = this.miembrosTableConfig.data;
    let ref = this.$refs.miembro_add_sin_cedula as MiembroAdd;
    let isValid = await ref.isValid();
    if (!isValid) return;

    if (data.some(x => this.equalPerson(x.persona, addingMiembro.persona))) {
      this.operationNoAllowed(
        "La persona ya es parte de la composición familiar"
      );
      return;
    }
    if (this.solicitante.id === addingMiembro.personaId) {
      this.operationNoAllowed(
        "El solicitante es el JEFE DEL HOGAR, ya es parte de la composición"
      );
      return;
    }

    if (!addingMiembro.personaId && addingMiembro.persona) {
      this.addingMiembro = true;
      addingMiembro.persona.cedula = this.quitCedulaMask(addingMiembro.persona.cedula);
      addingMiembro.persona.cedulaPadre = this.quitCedulaMask(addingMiembro.persona.cedulaPadre);
      addingMiembro.persona.cedulaMadre = this.quitCedulaMask(addingMiembro.persona.cedulaMadre);
      if (addingMiembro.persona.telefono)
        addingMiembro.persona.telefono = Helpers.Filters.PhoneToStr(addingMiembro.persona.telefono);
      if (addingMiembro.persona.estaEstudiando) addingMiembro.persona.ultimoNivelAcademico = undefined;
      else if (addingMiembro.persona.estaEstudiando === false) {
        addingMiembro.persona.centroAcademicoId = undefined;
        addingMiembro.persona.centroAcademicoOtro = undefined;
        addingMiembro.persona.cursoEstudiante = undefined;
      }
      let p = await this.repoPersona.create(addingMiembro.persona);
      addingMiembro.personaId = p.id;
      addingMiembro.persona = p;
      this.addingMiembro = false;
    }
    let miembro = this.map<SolicitudEvaluacionHogarMiembro>(
      addingMiembro
    ) as any;
    miembro.key = Utils.newGUID();
    this.miembrosTableConfig.data.push(miembro);
    this.solicitudEvaluacionHogar.miembros.push(miembro);
    this.adding = false;
    //this.setMiembros();
  }
  public onEditMiembro(
    id: number,
    row: SolicitudEvaluacionHogarMiembro,
    props: RowTable<SolicitudEvaluacionHogarMiembro>
  ) {
    this.editingMiembroModel = this.mapModel(row);
    this.editingMiembro = this.mapModel(row);
    this.editing = true;
  }
  equalPerson(a: Persona | undefined, b: Persona | undefined): boolean {
    let p = a as Persona;
    let t = b as Persona;
    if (p.cedula || t.cedula) return p.cedula === t.cedula;

    return (
      p.nombre1 === t.nombre1 &&
      p.apellido1 === t.apellido1 &&
      p.nombre2 === t.nombre2 &&
      p.apellido2 === t.apellido2
    );
  }
  onSaveEdit() {
    let index = this.miembrosTableConfig.data.findIndex(
      x =>
        x.key === (this.editingMiembro as SolicitudEvaluacionHogarMiembro).key
    );
    this.miembrosTableConfig.data.splice(
      index,
      1,
      this.mapModel(this.editingMiembroToSave)
    );

    let indexx = this.solicitudEvaluacionHogar.miembros.findIndex(
      x => x.key === (this.editingMiembroToSave as any).key
    );
    this.solicitudEvaluacionHogar.miembros.splice(
      indexx,
      1,
      this.mapModel(this.editingMiembroToSave)
    );
    this.editing = false;
    //this.setMiembros();
  }
  mapModel(obj: any) {
    let m = this.map<SolicitudEvaluacionHogarMiembro>(obj);
    let p = m.persona as Persona;
    (m.persona as Persona).nombreCompleto = `${p.nombre1} ${p.nombre2} ${p.apellido1} ${p.apellido2}`;
    return m;
  }

  editModelChange(value: SolicitudEvaluacionHogarMiembro) {
    this.editingMiembroToSave = value;
  }
  restartEdit() {
    this.editingMiembro = this.mapModel(this.editingMiembroModel);
  }
  closeEdit() {
    this.editing = false;
    this.editingMiembro = null;
    this.editingMiembroModel = null;
    this.editingMiembroToSave = null;
  }
  showModalAddMiembro() {
    this.closeAdd();
    this.adding = true;
  }
  closeAdd() {
    this.adding = false;
    this.miembroAddCedula = null;
    this.miembroAddSinCedula = null;
  }
  getValueDate(value: string) {
    return moment(value).format("L");
  }
  // setMiembros() {
  //   this.solicitudEvaluacionHogar.miembros = [];
  //   this.miembrosTableConfig.data.forEach(m =>
  //     this.solicitudEvaluacionHogar.miembros.push(m)
  //   );
  // }
  //   @Watch("model", { deep: true })
  //   set(model: SolicitudEvaluacionHogarModel) {
  //     if(this.content){
  //  let contenido = this.content as any;
  //     contenido.solicitudEvaluacionHogar = this.map<
  //       SolicitudEvaluacionHogarModel
  //     >(this.model);
  //     this.$emit("update:content", contenido);
  //     }
  //   }

  onChangeDocs(
    miembro: SolicitudEvaluacionHogarMiembro,
    tipos: any,
    docs: any[]
  ) {
    // let contenido = this.content as any;
    // let main = contenido.solicitudEvaluacionHogar as SolicitudEvaluacionHogarModel;
    // let member = main.miembros.find(
    //   x => x.personaId == miembro.personaId
    // ) as SolicitudEvaluacionHogarMiembro;

    // this.$emit("update:content", contenido);
    miembro.documentos = docs.map(x => {
      let doc = new SolicitudEvaluacionHogarMiembroDocumento();
      doc.personaId = miembro.personaId;
      doc.documentoId = x.documentoId;
      doc.documento = x.documento;
      doc.tipoDocumentoId = x.tipoDocumentoId;
      doc.tipoDocumentoNombre = x.tipoDocumentoNombre;
      return doc;
    });

    this.solicitudEvaluacionHogar.miembros.forEach(x => {
      if (x.personaId === miembro.personaId) {
        x.documentos = miembro.documentos;
      }
    });

    if (this.model) {
      let contenido = this.model as any;
      contenido.solicitudEvaluacionHogar = this.map<
        SolicitudEvaluacionHogarModel
      >(this.solicitudEvaluacionHogar);
      this.model = contenido;
    }
  }

  onChangeTipDocs(tipos: any[], docs: TramiteBeneficiarioDocumento[]) {
    this.tipoDocumentos = tipos;
    this.model.documentos = docs;
  }
  get solicitudDocumentosRef() {
    let docs = this.$refs.solicitudDocumentos as any;
    return Array.isArray(docs) ? docs[0] : docs;
  }
  get memberDocumentRefs() {
    let refs = this.$refs.miembroDocumentos as any;
    if (!refs) return [];
    return Array.isArray(refs) ? refs : [refs];
  }
  get telefonoFamiliarFueraHogar() {
    if (this.solicitudEvaluacionHogar.telefonoFamiliarFueraHogar)
      return Helpers.Filters.PhoneToStr(
        this.solicitudEvaluacionHogar.telefonoFamiliarFueraHogar
      );
    return "";
  }
  get parentescoRequiredError() {
    return !!(
      ((this.solicitudEvaluacionHogar.nombreFamiliarFueraHogar || "").trim() ||
        (this.solicitudEvaluacionHogar.telefonoFamiliarFueraHogar || "").trim()) &&
      !this.solicitudEvaluacionHogar.parentescoFamiliarFueraHogarId
    );
  }
  onSelectParentescoFueraHogar(value: NameValue | null) {
    this.solicitudEvaluacionHogar.parentescoFamiliarFueraHogarId = value
      ? value.id
      : undefined;
    this.solicitudEvaluacionHogar.parentescoFamiliarFueraHogarNombre = value
      ? value.descripcion
      : undefined;
  }
  onRemoveParentescoFueraHogar() {
    this.solicitudEvaluacionHogar.parentescoFamiliarFueraHogarId = undefined;
    this.solicitudEvaluacionHogar.parentescoFamiliarFueraHogarNombre = undefined;
  }
  getMissingRequiredDocuments(tipoDocumentos: any[]) {
    return (tipoDocumentos || []).filter(
      x => x.requerido && !x.fileSelected
    );
  }
  validateContactRequirements() {
    if (!this.solicitudEvaluacionHogar.direccionId) {
      this.operationFailed("Debe seleccionar una dirección para continuar.");
      return false;
    }
    if (
      !this.solicitudEvaluacionHogar.telefonos ||
      !this.solicitudEvaluacionHogar.telefonos.length
    ) {
      this.operationFailed(
        "Debe agregar al menos un número de teléfono para continuar."
      );
      return false;
    }
    if (this.parentescoRequiredError) {
      this.operationFailed("Debe seleccionar el parentesco de la persona para continuar.");
      return false;
    }
    return true;
  }
  validateSolicitudRequiredDocuments() {
    let tipoDocumentos =
      (this.solicitudDocumentosRef &&
        this.solicitudDocumentosRef.tipoDocumentos) ||
      this.tipoDocumentos;
    let missingDocs = this.getMissingRequiredDocuments(tipoDocumentos);
    if (!missingDocs.length) return true;

    let names = missingDocs.map(x => x.tipoDocumentoNombre).join(", ");
    this.operationFailed(
      `Debe adjuntar los documentos requeridos de la solicitud: ${names}`
    );
    return false;
  }
  validateMemberRequiredDocuments() {
    for (const docsRef of this.memberDocumentRefs) {
      let missingDocs = this.getMissingRequiredDocuments(docsRef.tipoDocumentos);
      if (!missingDocs.length) continue;

      let miembro = this.miembroRows.find(
        x => String(x.personaId) === String(docsRef.refValue)
      );
      let miembroNombre =
        miembro && miembro.persona
          ? this.getNombreCompleto(miembro.persona)
          : "el miembro seleccionado";
      let names = missingDocs.map(x => x.tipoDocumentoNombre).join(", ");
      this.operationFailed(
        `Debe adjuntar los documentos requeridos para ${miembroNombre}: ${names}`
      );
      return false;
    }
    return true;
  }
  async validateCurrentForm() {
    try {
      if (!this.$validator || typeof this.$validator.validateAll !== "function")
        return true;

      const isValid = await this.$validator.validateAll();
      if (isValid)
        return true;

      throw this.$validator.errors.items.map(e => e.msg);
    } catch (errors) {
      this.operationFailedErrors(errors);
      return false;
    }
  }
  public async isValid() {
    let isValid = await this.validateCurrentForm();
    if (!isValid) return false;
    if (!this.validateContactRequirements()) return false;
    if (!this.validateSolicitudRequiredDocuments()) return false;
    if (!this.validateMemberRequiredDocuments()) return false;
    return true;
  }
  public async validate() {
    if (this.submitting || this.saving)
      return;

    this.submitting = true;
    try {
      let isValid = await this.isValid();
      if (!isValid) return;

      await this.add();
    } finally {
      this.submitting = false;
    }
  }
  public async onWizardComplete() {
    return this.validate();
  }
  @Watch("solicitudEvaluacionHogar", { deep: true })
  set(value: SolicitudEvaluacionHogarModel) {
    if (this.model) {
      let contenido = this.model as any;
      contenido.solicitudEvaluacionHogar = this.map<
        SolicitudEvaluacionHogarModel
      >(value);
      contenido.solicitudEvaluacionHogar.telefonoFamiliarFueraHogar =
        this.telefonoFamiliarFueraHogar;
      this.model = contenido;
    }
  }

  public async add() {
    try {
      if (this.saving) return;

      this.saving = true;
      let result = await this.repository.create(this.model);
      this.saving = false;
      this.$emit("add", result);
      this.clean();
      this.$buefy.dialog.confirm({
        canCancel: false,
        title: "Solicitud enviada!",
        message: `La solicitud fue enviada con exito! <br/>Número de solicitud: <br/> <b>${result.numeroTramite}</b>`,
        type: "is-success",
        hasIcon: true,
        onConfirm: () => this.$router.push(`/`)
      });
      //  if (this.exitOnSave) this.confirmedCancel();

      //  this.$router.push(`/`);
    } catch (errors) {
      this.operationFailedErrors(errors);
    } finally {
      this.saving = false;
    }
  }
  @Watch("codigoMiembrosDocAdicionales", { immediate: true })
  async onCodigoDocAdicionalesChange(value: string) {
    if (value) {
      this.nameValue = await new BaseRepository<NameValue>("namevalues").one(
        `codigo="${value}"`
      );
    }
  }
}
